<template>
  <div class="page-main draft-box">
    <div>
      <SearchTop moduleTitle="VGM" @search="search" ref="header"> </SearchTop>
      <div class="page-table">
        <div v-if="!firstUseType">
          <div class="btn-div">
            <el-button type="primary" icon="iconfont icon-daorucangdan" @click="exportCps">表格导入</el-button>
            <!-- <el-button type="primary" disabled>button</el-button> -->
            <!-- <el-button type="success">button</el-button> -->
            <el-button type="info" icon="iconfont icon-xinjiancangdan" @click="addCps">在线新增</el-button>
            <el-button type="primary" icon="iconfont icon-fasong" :disabled="unSendDisabledType" @click="moveSent">发送</el-button>
            <el-button type="primary" icon="el-icon-delete" :disabled="disabledType" @click="deleteMsg">删除</el-button>
          </div>
          <WTable :WTableOpts="WTableOpts" @selection-change="handleSelectionChange">
            <template #validMessage="{ row }">
              <div style="text-align: center">
                <el-popover trigger="hover" v-if="!row.valid">
                  <div style="max-height: 300px; overflow-y: auto">
                    <p class="errorTipLine">
                      {{ row.validMessage }}
                    </p>
                  </div>
                  <span slot="reference" style="color: #f56c6c; cursor: pointer"><i class="iconfont icon-zhuangtai-cuowu"></i></span>
                </el-popover>

                <span v-else style="color: #12BF1B"><i class="iconfont icon-zhuangtai-zhengque"></i></span>
              </div>

            </template>
            <template #containers="{ row }">
              <div style="text-align: center">
                <div v-for="(item, index) in row.vgmListContainers" :key="item.id">
                  <p style="height: 40px; line-height: 40px" :style="{
                                    borderTop: index > 0 ? '1px solid #EBEEF5' : '',
                                  }">
                    {{ item.containerNo }}
                  </p>
                </div>
              </div>
            </template>
            <template #portCode="{ row }">
              <span>{{ row.portCode }}
                <i style="font-size: 13px; color: #999; font-style: normal">({{ portCodes[row.portCode] }})</i></span>
            </template>

            <template #vgmWeight="{ row }">
              <div>
                <div v-for="(item, index) in row.vgmListContainers" :key="item.id">
                  <p style="height: 40px; line-height: 40px;text-align: center" :style="{
                        borderTop: index > 0 ? '1px solid #EBEEF5' : '',
                      }">
                    {{ item.vgmWeight }}
                  </p>
                </div>
              </div>
            </template>
            <template #userRemark="{ row }">
              <div>
                <span @click="updateNotes(row)" style="color:#1170EB;cursor: pointer">{{row.userRemark || '添加备注'}}</span>
              </div>
            </template>

            <template #operation="{ row }">
              <div class="table-btn">
                <el-link type="primary" @click="editDraft(row)" :underline="false">编辑</el-link>
                <el-link type="primary" @click="copyDraft(row)" :underline="false" style="margin-left: 16px">复制</el-link>
              </div>
            </template>
          </WTable>
          <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :pageNum="pageNum" :pageSize="pageSize" :total="total"></Pagination>
        </div>
        <!-- 发送-费用确认提示 -->
        <SendFeeTip v-if="sendFeeTipVisible" :visible="sendFeeTipVisible" :feeData="feeData" @closeDialog="closeFee" @sendSuccess="sendSuccess" />
        <FirstEmpty v-if="firstUseType" @exportCps="exportCps" @addCps="addCps" />
        <WUploadDialog ref="refWUploadDialog" title="导入VGM" product="CPS" :fileTemplate="fileTemplate" :action="action" :headers="headers" :on-success="handleSuccessTwo" :on-error="handleError" :setupTxtArr="['第二步：填入下载的VGM模版信息，按模版内容格式填写', '第三步：上传已填写完整的模版']" :before-upload="handleUpload">
          <template slot="footer">
            <el-button style="width:80px;float:right;margin:20px 0 20px 0" @click="cancelImport">取消</el-button>
          </template>
        </WUploadDialog>
        <RemarksPopup v-if="delDialogVisible" :delDialogVisible="delDialogVisible" :userRemark="userRemark" @closedelDialog="closedelDialog" @confirmTheChanges="confirmTheChanges"></RemarksPopup>
      </div>
    </div>

  </div>
</template>
<script>
import {portCodes} from "@/utils/enum";
import SearchTop from "../../searchHead/Search";
import Pagination from "@/components/pagination/index.vue";
import FirstEmpty from '@/components/FirstEmpty'
import SendFeeTip from '../component/SendFeeTip'
import {getDraftBoxList, delDraftBox, feeConfirmation, updateNotes, firstTimeUsing} from "@/api/vgmBusiness";
import RemarksPopup from "@/views/new_vgm/component/remarksPopup";
import { MODE_CONF } from '@/utils/config'

export default {
  components: {
    RemarksPopup,
    SearchTop,
    Pagination,
    FirstEmpty,
    SendFeeTip
  },
  data () {
    return {
      portCodes,
      firstUseType:false,//引导
      action: MODE_CONF.base_url_agent + '/agent/website/batchImportExcel',
      headers: {'token': localStorage.getItem('userToken')},
      fileTemplate: {
        name: 'VGM模版.xlsx',
        url: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/template/VGM%E6%95%B0%E6%8D%AE%E6%A8%A1%E6%9D%BF.xlsx'
      },
      // list:[],//选中的数据
      chooseList: [], // 选中id数据
      validList: [],
      sendFeeTipVisible:false,
      feeData: {}, // 价格数据
      total:0,
      pageSize:10,
      pageNum:1,
      searchData:"",
      WTableOpts: {
        data: [],
        tableAttrs: {},
        tableColAttrs: [
          { type: "selection" },
          //   {type:"index", label: "序号",width: "60px", },
          // { prop: "taskName", label: "计划名称",slotName:"taskName",width: '120px' },
          // { prop: "taskType", label: "计划属性",width: '120px' },
          { label: "校验状态",slotName: 'validMessage',width: '90px'},
          {  label: "起运港",slotName: 'portCode' ,width: '120px'},
          { prop: "billNo", label: "提单号",width: '180px' },
          {  label: "箱号",slotName: 'containers',width: '160px' },
          {  label: "VGM重量(KGS)",slotName: 'vgmWeight' ,width: '140px'},

          {
            prop: "carrierName",
            label: "船公司",

          },
          {
              prop: 'userNickName',
              label: '提交人'
          },
          {
              prop: 'gmtModified',
              label: '修改时间',
              width: '110px'
          },
          { slotName: "userRemark", label: "客户备注",minWidth:'120px' },


          {
            prop: "",
            label: "操作",
            slotName: "operation",
            fixed: "right",
            width: "220px",
          },
        ],
      },
      delDialogVisible:false,
      userRemark:'',//备注内容
      id:"",//点击修改备注的id
    }
  },
  created () {
    let domain = '';
    if (window.location.host.split('.')[0] == 'www') {
      domain = window.location.host.split('.')[1];
    } else {
      domain = window.location.host.split('.')[0];
    }
    this.headers['X-company-domain'] = domain;
    this.firstTimeUsing()
  },
  mounted () {
// this.getDraftBoxList()
  },
  computed: {

    // 删除 按钮状态
    disabledType(){
      return this.chooseList.length > 0 ? false : true
    },
    // 待发送 按钮状态
    unSendDisabledType(){
      console.log(this.validList,180)
      return this.validList.every(o => !o ) && this.chooseList.length > 0 ? false : true
    },
  },
  methods: {
    //是否首次使用
    firstTimeUsing() {
        firstTimeUsing().then((res) => {
            this.firstUseType = res
        })
    },
    updateNotes(row){
      this.id=row.id
      this.userRemark = row.userRemark
      this.delDialogVisible=true
    },
    closedelDialog(){
      this.delDialogVisible=false
    },
    confirmTheChanges(remark){
      updateNotes({remark,ids:[this.id]}).then(res=>{
        this.delDialogVisible=false
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.getDraftBoxList()
      })
    },
    //费用确认
    feeConfirmation(){
      feeConfirmation({useCouponAmount:0,ids:this.chooseList}).then(res=>{
        this.feeData=res
        this.feeData.ids=this.chooseList
        this.sendFeeTipVisible=true

      })
    },
    // 编辑按钮
    editDraft(row){
      this.$router.push({
        name:"vgmDetails",
        query:{
          vgmId:row.id,
          type:'edit'
        }
      })
    },
    //复制按钮
    copyDraft(row){
      delete row.vgmSn
      this.$router.push({
        name:"vgmDetails",
        query:{
          vgmId:row.id,
          type:'copy'
        }
      })
    },


    //草稿箱列表查询
    getDraftBoxList(){
      const obj={
        ...this.searchData,
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        vgmType:"DRAFT"
      }
      getDraftBoxList(obj).then(res=>{
        this.WTableOpts.data=res.records
        this.total=res.total
      })
    },
    // 切换条数
    handleSizeChange({pageSize}) {
      this.pageSize = pageSize
  this.getDraftBoxList()
    },
    // 切换页码
    handleCurrentChange({pageNum}) {

      this.pageNum = pageNum
      this.getDraftBoxList()

    },
    // 价格弹窗
    closeFee(){
      this.sendFeeTipVisible = false
    },
    // 发送成功
    sendSuccess(data){
      this.$message({
        message: '发送成功',
        type: 'success'
      })
      this.pageNum=1
      this.closeFee()
      this.getDraftBoxList()
      this.$refs.header.getAccount()
    },
    // 发送
    moveSent(){
      // feeItems
      this.feeConfirmation()
      // drafts.moveSent(this.chooseList).then(res => {
      // this.$message({
      //   message: '操作成功',
      //   type: 'success'
      // })
      //   this.getList()
      // })
    },
    // 删除
    deleteMsg(){
      this.$confirm('确定要删除当前数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delDraftBox(this.chooseList).then(res => {
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        this.search();
        })
      })
    },
    //取消导入
    cancelImport(){
      this.$refs.refWUploadDialog.close()
    },
    // 导入成功
    handleSuccess(response, file, fileList) {
      console.warn(response, file, fileList)
      this.$router.push({
        name:"vgmDetails",
        query:{
          data:JSON.stringify(response),
          type:'import'
        }
      })
      this.firstUseType = false;
      this.$refs.refWUploadDialog.close()
    },
    handleSuccessTwo(response, file, fileList) {
      this.$message({
        message: '导入成功',
        type: 'success'
      })
      this.firstUseType = false;
      this.$refs.refWUploadDialog.close()
      this.$refs.header.resetForm()
      this.search();
    },
    handleError(err, file, fileList) {
      console.log(err.message)
      console.warn(err, file, fileList)
    },
    // 上传校验
    handleUpload(file) {
      console.log('上传文件校验')
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      const whiteList = ['xls', 'xlsx']
      if (whiteList.indexOf(fileSuffix) === -1) {
          this.$message({
            message: '上传文件只能是xls、xlsx格式',
            type: 'error'
          })
          this.$refs.refWUploadDialog.$refs.refWUpload.$children[0].clearFiles()
          return false
      }else if (file.size > (1024 * 1024 * 5)) {
        this.$message({
          message: '附件不能大于5M',
          type: 'error'
        })
        this.$refs.refWUploadDialog.$refs.refWUpload.$children[0].clearFiles()
        return false
      }
      //this.$refs.refWUploadDialog.$refs.refWUpload.$children[0].submit()
    },
    // table 选择
    handleSelectionChange(e){
      console.log(e)
      // this.list=e
      // this.feeData.feeItems=e
      this.chooseList = []
      this.validList = []
      this.chooseList = e.map(o => o.id)
      this.validList = e.map(o => !o.valid)

    },
    // 导入舱单
    async exportCps(){
      let flag = await this.$refs.refWUploadDialog.open()
      console.warn(flag)
    },
    //新增vgm
    addCps(){
      this.$router.push({
        name:"vgmDetails"
      })
    },
    search (val) {
      console.log(val)
      this.searchData=val
      this.pageNum = 1
      this.getDraftBoxList()
    }
  },
}
</script>
<style lang="less" scoped>
.draft-box {
  .btn-div {
    margin-bottom: 24px;
  }
}
</style>